import {getBFF} from "@/function/getUrlProdOrPreprod";
import {Adresse} from "@/ts/interface/compte";

import adresseMock from "../data/getAdresse.json";
import {getDataMock} from "./_callApi";
import {callApi} from "./_callApi";

export async function fetchAdresse(): Promise<
  {adresses: Adresse[]} | undefined
> {
  if (getDataMock()) {
    return adresseMock;
  }
  if (import.meta.env.VITE_APP_DEV === "true") {
    const reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/massification/v1/addresses`,
      "GET",
      {
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
    );
    const allAdresse: Adresse[] = reponse.map((adresse: any) => {
      const {address_id, value, is_default, label} = adresse;
      return {
        adresse_id: address_id,
        libelle: label,
        value: value,
        is_default: is_default,
      };
    });
    return {adresses: allAdresse};
  } else {
    const reponse = await callApi(
      `${getBFF()}/massification/v1/addresses`,
      "GET",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      null,
    );

    const allAdresse: Adresse[] = reponse.map((adresse: any) => {
      const {address_id, value, is_default, label} = adresse;
      return {
        adresse_id: address_id,
        libelle: label,
        value: value,
        is_default: is_default,
      };
    });
    return {adresses: allAdresse};
  }
}
